import { ChangeEvent } from 'react';
import styles from './Input.module.scss';
import { Icon } from '../Icon';
import clsx from 'clsx';

type InputT = {
  type?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  readonly?: boolean;
  className?: string;
  name?: string;
  hidden?: boolean;
  value?: string | null;
  minlength?: number;
  maxlength?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  closeble?: boolean;
  handleClear?: () => void;
  onBlur?: () => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  icon?: string;
  iconSize?: string;
  disabled?: boolean;
  id?: string;
  checked?: boolean;
  label?: string;
  onClick?: (e?: any) => void;
  min?: number;
  max?: number;
  step?: number;
  isNotReal?: boolean;
  labelClass?: string;
};

export const Input = ({
  onChange,
  type,
  placeholder,
  readonly,
  className,
  name,
  hidden,
  value,
  maxlength,
  minlength,
  onKeyDown,
  closeble = false,
  handleClear,
  onBlur,
  onFocus,
  icon,
  iconSize,
  disabled = false,
  id,
  checked,
  label,
  onClick,
  isNotReal = type === 'number',
  labelClass,
  ...inputProps
}: InputT) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (isNotReal) {
      ['e', 'E', '+'].includes(e.key) && e.preventDefault();
    }
    onKeyDown?.(e);
  };

  return (
    <label className={clsx(styles.label, labelClass)} data-type={type} onClick={onClick}>
      <input
        id={id}
        maxLength={maxlength}
        minLength={minlength}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value || ''}
        hidden={hidden}
        type={type}
        placeholder={placeholder}
        readOnly={readonly}
        className={clsx(styles.input, className)}
        name={name}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        checked={checked}
        {...inputProps}
      />
      {closeble && value && <Icon name="close-16" size="16px" onClick={handleClear} className={styles.close} />}
      {icon && <Icon name={icon} size={iconSize ? iconSize : '24px'} />}
      {type === 'radio' && <div className={styles.radio_wrapper}>{label}</div>}
      {type === 'checkbox' && <span className={styles.checkbox_wrapper}>{label}</span>}
    </label>
  );
};
